import axiosInstant from "../../axiosInstant";





 // src/api/paymongo.js  (or kung saan mo nilalagay ang api calls)


export async function getPaymongoPaymentIntent(paymentIntentId) {
  const response = await axiosInstant
    .get(`v_1/paymongo/payment-intents/${paymentIntentId}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      }
      return {
        success: false,
        message: "Network error",
      };
    });

  return response;
}




export async function GetUpcomingAuctions(page = "", live = null, timeAuction = null, online = null) {
  try {
    // Siguraduhin na walang double '?' sa URL
    const queryPage = page ? `page=${page}` : "page=1";
    const queryLive = live ? `&category=${live}` : "";
    const queryTime = timeAuction ? `&category=${timeAuction}` : "";
    const queryOnline = online ? `&category=${online}` : "";
    
    const finalUrl = `auction?${queryPage}${queryLive}${queryTime}${queryOnline}`;
    
    // DEBUG: Tingnan kung tama ang URL na tinatamaan
    console.log("Requesting URL:", finalUrl);

    const response = await axiosInstant.get(finalUrl);

    // DEBUG: Tingnan ang raw message mula sa server bago i-filter
    console.log("Raw API Response msg:", response.data?.msg);

    if (response.data && response.data.status) {
      const filteredResult = response.data.msg.filter((item) => {
        const isValidType = 
          item.c_type === "LIVE_AUCTION" ||
          item.c_type === "ONLINE_AUCTION" ||
          item.c_type === "TIME_AUCTION";

        // Minsan ang API ay nagbabalik ng lowercase (upcoming) o uppercase (UPCOMING)
        // Gamitan natin ng toUpperCase() para safe
        const isUpcoming = item.auction_status?.toUpperCase() === "UPCOMING" || item.auction_status?.toUpperCase() === "ONGOING";

        return isValidType && isUpcoming;
      });

      console.log("Final Filtered Result:", filteredResult);

      return {
        status: true,
        data: filteredResult
      };
    }

    return { status: false, data: [] };
  } catch (error) {
    console.error("API Error in GetUpcomingAuctions:", error);
    return { status: false, data: [], error: error?.response?.data || 'Unexpected error' };
  }
}


export async function getCurrentAUctionList(storedAuctionID) {
  const response = await axiosInstant.get(`lot?auction_id=${storedAuctionID}&search=&set_id=&page&userid&cat=&fav=&limit=1000`)
    .then((res) => {
      // ////console.log("ot/next: ",res.data)
      return res.data;

    })

    .catch((error) => {
    //  ////console.log("ot/next: ",error.response.data)
    return error.response.data;
    });
  return response;
}



export async function Winning(page, search = "") {
  const response = await axiosInstant 
    .get(`user/me/winning-lots?page=${page === undefined ? 1 : page}&limit=12&search=${search}`) 
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return response;
}

export async function GetApprovedAuction(auction_id) {
  try {
    const response = await axiosInstant.get(`user/me/approved/${auction_id}`);
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Unexpected error occurred.' };
  }
}


export async function getInvoiceList(search = "", status = "", start = 0, limit = 100) {
  try {
    const response = await axiosInstant.get("invoice", {
      params: {
        search,
        status,
        start,
        limit,
      },
    });
    return response.data; // Return the data directly (assuming axios response has data field)
  } catch (error) {
    return error?.response?.data || { error: "Unexpected error occurred." };
  }
}



export async function getInvoiceDetail(invoiceId) {
  try {
    const response = await axiosInstant.get(`invoice/${invoiceId}`);
    return response.data; // assuming the API returns { success, data, lot, payment_url }
  } catch (error) {
    console.error("Error fetching invoice detail:", error);
    return error?.response?.data || { success: false, message: "Unexpected error occurred." };
  }
}



export async function Profile() {
  const response = await axiosInstant 
  //declarator/current
    .get(`user/me`) 
    .then((res) => {
     // //console.log('ressssss data  dot', res)
      return res.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return response;
}

export async function ChangePassword(data) {

  const response = await axiosInstant 
  //declarator/current
    .post(`user/me/change-password`,data) 
    .then((res) => {
     // //console.log('ressssss data  dot', res)
      return res.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return response;
}



export async function auctionsLiveDeclarator() {
  const response = await axiosInstant 
  //declarator/current
    .get(`declarator/current`) 
    .then((res) => {
      ////console.log('ressssss data  dot', res)
      return res.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return response;
}


export async function auctionsLive() {
  
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .get(`live/current`)
    .then((res) => {
      // ////console.log('res.data.lot.detils: ',res.data)
      return res.data;
    })
    .catch((error) => {
    //  //console.log("auctionsLive ",error.response.data.sucess)
    return error.response.data;
    });
  return response;
}


export async function GetauctionsLive() {
  
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .get(`live/current`)
    .then((res) => {
      //console.log('res.data.lot.detils: ',res.data)
      return res.data.lot;
    })
    .catch((error) => {
    return error.response.data;
    });
  return response;
}



export async function getLotByAll(liveData) {
  const response = await axiosInstant.get(`lot?auction_id=${liveData.auction_id}&search=&set_id=&page&userid&cat=&fav=&limit=2000`)
    .then((res) => {
      // ////console.log("ot/next: ",res.data)
      return res.data;

    })

    .catch((error) => {
    //  ////console.log("ot/next: ",error.response.data)
    return error.response.data;
    });
  return response;
}



export async function nextAuction(liveData,data) {
  const response = await axiosInstant.get(`live/lot/next?auction_id=${liveData.auction_id}&setId=${liveData.setId}&lot_number=${data === undefined ?  liveData.LotNo: data.nextCount}`)
    .then((res) => {
      // ////console.log("ot/next: ",res.data)
      return res.data;

    })

    .catch((error) => {
    //  ////console.log("ot/next: ",error.response.data)
    return error.response.data;
    });
  return response;
}







export async function prevAuction(data) {
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .get(`live/lot/prev?auction_id=${data.auction_id}&setId=${data.setId}&lot_number=${data.LotNo}`)
    .then((res) => {
      // ////console.log('res.data.lot.detils: ',res.data)
      return res.data;
    })
    .catch((error) => {
      // ////console.log("error.response.data",error.response.data);
    return error.response.data;
    });
  return response;
}




export async function postBid(data) {
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .post(`live/placeBid`,data)
    .then((res) => {
      // ////console.log('res.data.lot.detils: ',res.data)
      return res.data;
    })
    .catch((error) => {
      // ////console.log("error.response.data",error.response.data.msg);
      if(error.response.data.success === false ){
        return error.response.data.msg
      }else{
        return error.response.status;
      }
  
    });
  return response;
}


export async function postPlaceBid(data) {
// //console.log('model auction postPlaceBid: ',data)
  const response = await axiosInstant
    .post(`live/bid`,data)
    .then((res) => {
      // ////console.log('res.data.lot.detils: ',res.data)
      return res.data;
    })
    .catch((error) => {
      // ////console.log("error.response.data",error.response.data.msg);
      if(error.response.data.success === false ){
        return error.response.data
      }else{
        return error.response.status;
      }
  
    });
  return response;
}









export async function mainAuction(auction_status) {
  
  const response = await axiosInstant
    .get(
      `/auction?category=LIVE_AUCTION&page=1&auction_status=${auction_status=== undefined ? 'UPCOMING':auction_status}`
    )
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    });
  return response;
}

export async function lafuerzaAuction(auction_status) {
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .get(
      `/auction?category=ONLINE_AUCTION&page=1&auction_status=${auction_status=== undefined ? 'UPCOMING':auction_status}`
    )
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    });
  return response;
}


export async function international(auction_status) {
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .get(
      `/auction?category=EXHIBITION&page=1&auction_status=${auction_status === undefined ? 'UPCOMING':auction_status}`
    )
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      ////console.log(error.response.data);
    });
  return response;
}






export async function getFilter(id) {
  // ////console.log('model auction: ',exhibition)
  const response = await axiosInstant
    .get( `lot/set?auction_id=${id=== undefined ? '': id}`
    )
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      ////console.log(error.response.data);
    });
  return response;
}


export async function privatefilterArtist(id) {
  const response = await axiosInstant
    .get(
      `private-sales/filtering?id=${id}&pgroup=PRIVATE_SALE`
    )
    .then((res) => {

      return res.data;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    return error.response.data.message;
    });
  return response;
}





export async function filterArtist(id) {
  const response = await axiosInstant
    .get(
      `lot/filtering?auction_id=${id}&limit=10`
    )
    .then((res) => {

      return res.data;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    return error.response.data.message;
    });
  return response;
}

 

export async function privateGroupFilter(group) {
  const response = await axiosInstant
    .get(
      `private-sales/filtering?id=0&pgroup=PRIVATE_SALE`
    )
    .then((res) => {
// ////console.log('res data: ',res.data.data)
      return res.data.data;
    })
    .catch((error) => {
      ////console.log(error.response.data);
    });
  return response;
}


export async function categories() {
  const response = await axiosInstant
    .get(
      `private-sales/categories`
    )
    .then((res) => {

      return res.data.data;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    });
  return response;
}

export async function actionByID(id) {
  const response = await axiosInstant
    .get(
      `auction/${id}`
    )
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    });
  return response;
}


export async function exhibitionBannerByID(id) {
  const response = await axiosInstant
    .get(
      `private-sales/details?id=${id}&page=`
    )
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      // ////console.log(error.response.data);
    });
  return response;
}




export async function requestForApproval(auctionID) {

  const response = await axiosInstant
    .get(
      `users/joiner/${auctionID}`
    )
    .then((res) => {
      // console.log(' res.data: ', res.data)
      return res.data;
    })
    .catch((error) => {
      // console.log(' error.response.data.message: ', error.response.data.message)
      return error.response.data.sucess;
    });
  return response;
}

export async function getApprove(id) {
  try {
    const res = await axiosInstant.put(`users/approve-joiner/${id}`);
    // Fix the typo here
    return {
      success: res.data.sucess, // note the typo 'sucess' from API
      message: res.data.msg || "",
      ...res.data, // in case you want the full response
    };
  } catch (error) {
    console.error("Approval error:", error?.response?.data || error.message);

    return {
      success: false,
      message: error?.response?.data?.msg || "An error occurred.",
    };
  }
}

export async function getDecline(id) {
  try {
    const res = await axiosInstant.put(`http://157.230.43.47:3000/api/users/decline-joiner/${id}`);
    // Fix the typo here
    return {
      success: res.data.sucess, // note the typo 'sucess' from API
      message: res.data.msg || "",
      ...res.data, // in case you want the full response
    };
  } catch (error) {
    console.error("Approval error:", error?.response?.data || error.message);

    return {
      success: false,
      message: error?.response?.data?.msg || "An error occurred.",
    };
  }
}


